import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { formatDateTime } from "@/lib/format";

const REASON_LABEL = {
  bad_password: "Bad password",
  user_not_found: "User not found",
  user_locked: "Account locked",
  user_inactive: "Account inactive",
  password_reset_requested: "Password reset requested",
};

export default function LoginHistoryPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/auth/login-history?limit=100").then(({ data }) => setRows(data));
  }, []);

  return (
    <div className="space-y-4" data-testid="login-history-page">
      <p className="text-sm text-muted-foreground">Every login attempt on your account, most recent first.</p>

      <div className="border border-border rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 border-b border-border">
            <tr className="text-left">
              <th className="px-3 py-2 font-medium text-xs text-muted-foreground w-8"></th>
              <th className="px-3 py-2 font-medium text-xs text-muted-foreground">When</th>
              <th className="px-3 py-2 font-medium text-xs text-muted-foreground">Result</th>
              <th className="px-3 py-2 font-medium text-xs text-muted-foreground">IP address</th>
              <th className="px-3 py-2 font-medium text-xs text-muted-foreground">Device</th>
            </tr>
          </thead>
          <tbody>
            {rows === null && (
              <tr><td colSpan={5} className="px-3 py-8 text-center text-muted-foreground text-sm">
                <Loader2 size={14} className="animate-spin inline mr-2" /> Loading…
              </td></tr>
            )}
            {rows?.length === 0 && (
              <tr><td colSpan={5} className="px-3 py-8 text-center text-muted-foreground text-sm">No login attempts yet.</td></tr>
            )}
            {rows?.map((r) => (
              <tr key={r.id} className="border-b border-border last:border-0 hover:bg-muted/40" data-testid={`login-row-${r.id}`}>
                <td className="px-3 py-2.5">
                  {r.success ? (
                    <CheckCircle2 size={14} className="text-emerald-600" />
                  ) : (
                    <XCircle size={14} className="text-red-500" />
                  )}
                </td>
                <td className="px-3 py-2.5 text-xs font-mono">{formatDateTime(r.created_at)}</td>
                <td className="px-3 py-2.5 text-xs">
                  {r.success
                    ? <span className="text-emerald-600 dark:text-emerald-400">Success</span>
                    : <span className="text-muted-foreground">{REASON_LABEL[r.failure_reason] || r.failure_reason || "Failed"}</span>}
                </td>
                <td className="px-3 py-2.5 text-xs font-mono text-muted-foreground">{r.ip_address || "—"}</td>
                <td className="px-3 py-2.5 text-xs text-muted-foreground max-w-md truncate" title={r.user_agent}>{r.user_agent || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
